import axiosInstance, { getDefaultRequestConfig } from './base/axios.client';

export async function getPumps(): Promise<any> {
  return await axiosInstance.get('/pumps', getDefaultRequestConfig());
}

export async function getPump(pumpHash: string): Promise<any> {
  return await axiosInstance.get(
    `/pumps/${pumpHash}`,
    getDefaultRequestConfig()
  );
}

export async function getPumpSpeedXls(
  pumpHash: string,
  speedIds?: string[]
): Promise<any> {
  const config = getDefaultRequestConfig();
  if (speedIds && speedIds.length > 0) {
    const searchParams = new URLSearchParams();
    speedIds.forEach((id) => searchParams.append('speedIds', id));
    return await axiosInstance.get(
      `/pumps/${pumpHash}/xls/speeds?${searchParams.toString()}`,
      config
    );
  }
  return await axiosInstance.get(`/pumps/${pumpHash}/xls/speeds`, config);
}

export async function getPumpCurvesPdf(
  pumpHash: string,
  speedIds?: string[]
): Promise<any> {
  const config = getDefaultRequestConfig();
  if (speedIds && speedIds.length > 0) {
    const searchParams = new URLSearchParams();
    speedIds.forEach((id) => searchParams.append('speedIds', id));
    return await axiosInstance.get(
      `/pumps/${pumpHash}/pdf/curves?${searchParams.toString()}`,
      config
    );
  }
  return await axiosInstance.get(`/pumps/${pumpHash}/pdf/curves`, config);
}
